// Click-outside from BosNaufal: https://github.com/BosNaufal/vue-click-outside
const clickOutside = {
  bind: function bind(el, binding) {
    const { bubble } = binding.modifiers;
    const handler = function handler(e) {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;
    document.addEventListener('click', handler);
  },

  unbind: function unbind(el) {
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  },
};

export default clickOutside;
